"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var httpChannel_1 = require("./httpChannel");
var webSocketChannel_1 = require("./webSocketChannel");
var companionClientWrappers_1 = require("./companionClientWrappers");
var utils_1 = require("./utils");
var CompanionClient = (function () {
    function CompanionClient(companionConfig, logger, metricService, companionClientEventHandler, initialHandshakeMethods) {
        var _this = this;
        this.getConnectionChannel = function () {
            if (!!_this.connectionChannel) {
                return _this.connectionChannel;
            }
            else {
                var errorMessage = 'Access connectionChannel before it is set. Try to use AwaitUntilConnectionChannelSet wrapper to ensure that connectionChannel is set before being used';
                _this.logger.error(errorMessage);
                _this.metricService.newCounterMetric('get_connection_channel_before_setting_it');
                throw Error(errorMessage);
            }
        };
        this.setConnectionChannel = function (handshakeMethods) {
            if (handshakeMethods === void 0) { handshakeMethods = ['QUICK']; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var successLatencyHandler, failLatencyHandler, error_1, error_2;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            successLatencyHandler = this.metricService.newLatencyMetric("HTTP.setConnectionChannel.Success");
                            failLatencyHandler = this.metricService.newLatencyMetric("UNDEFINED.setConnectionChannel.Fail");
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 8, , 9]);
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 6]);
                            return [4, this.httpChannel.connect({ handshakeMethods: handshakeMethods })];
                        case 3:
                            _a.sent();
                            this.connectionChannel = this.httpChannel;
                            return [3, 6];
                        case 4:
                            error_1 = _a.sent();
                            successLatencyHandler = this.metricService.newLatencyMetric("WS.setConnectionChannel.Success");
                            return [4, this.wsChannel.connect({ handshakeMethods: handshakeMethods })];
                        case 5:
                            _a.sent();
                            this.connectionChannel = this.wsChannel;
                            return [3, 6];
                        case 6: return [4, this.setAccessTokenBeforeConnectionChannelSet()];
                        case 7:
                            _a.sent();
                            successLatencyHandler.stopAndEmitMetric();
                            return [3, 9];
                        case 8:
                            error_2 = _a.sent();
                            failLatencyHandler.stopAndEmitMetric();
                            this.logger.error('setConnectionChannel error', error_2);
                            throw error_2;
                        case 9: return [2];
                    }
                });
            });
        };
        this.companionConfig = companionConfig;
        this.logger = logger;
        this.metricService = metricService;
        this.httpChannel = new httpChannel_1.HttpChannel(this.companionConfig, this.logger, this.metricService);
        this.wsChannel = new webSocketChannel_1.WebSocketChannel(this.companionConfig, this.logger, this.metricService);
        this.companionClientEventHandler = companionClientEventHandler;
        this.connectionChannelSettingPromise = this.setConnectionChannel(initialHandshakeMethods);
        this.connectionChannelSettingPromise.then(function () {
            _this.connectionChannelSettingPromise = null;
        }, function () {
            _this.connectionChannelSettingPromise = null;
        });
        if (!!companionClientEventHandler) {
            companionClientEventHandler({ event: 'INITIALIZING', data: this.connectionChannelSettingPromise });
        }
    }
    CompanionClient.prototype.downloadFolder = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var impl;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impl = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var downloadFolderRequest, response;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (params.recursive === undefined) {
                                            params.recursive = true;
                                        }
                                        downloadFolderRequest = {
                                            Operation: 'DownloadFolder',
                                            Parameters: params,
                                        };
                                        return [4, this.connectionChannel.sendRequest(downloadFolderRequest)];
                                    case 1:
                                        response = _a.sent();
                                        if (utils_1.isExceptionalResponse(response)) {
                                            throw new Error(response.ExceptionMessage);
                                        }
                                        return [2, response.Result];
                                }
                            });
                        }); };
                        return [4, this.logAwaitRetryCBHandshake(impl, 'downloadFolder')()];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    CompanionClient.prototype.downloadFoldersAndFiles = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var impl;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impl = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var downloadFoldersAndFilesRequest, response;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        downloadFoldersAndFilesRequest = {
                                            Operation: 'DownloadFoldersAndFiles',
                                            Parameters: params,
                                        };
                                        return [4, this.connectionChannel.sendRequest(downloadFoldersAndFilesRequest)];
                                    case 1:
                                        response = _a.sent();
                                        if (utils_1.isExceptionalResponse(response)) {
                                            throw new Error(response.ExceptionMessage);
                                        }
                                        return [2, response.Result];
                                }
                            });
                        }); };
                        return [4, this.logAwaitRetryCBHandshake(impl, 'downloadFoldersAndFiles')()];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    CompanionClient.prototype.downloadActivityFeeds = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var impl;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impl = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var downloadActivityFeedsRequest, response;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        downloadActivityFeedsRequest = {
                                            Operation: 'DownloadActivityFeeds',
                                            Parameters: params,
                                        };
                                        return [4, this.connectionChannel.sendRequest(downloadActivityFeedsRequest)];
                                    case 1:
                                        response = _a.sent();
                                        if (utils_1.isExceptionalResponse(response)) {
                                            throw new Error(response.ExceptionMessage);
                                        }
                                        return [2, response.Result];
                                }
                            });
                        }); };
                        return [4, this.logAwaitRetryCBHandshake(impl, 'downloadActivityFeeds')()];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    CompanionClient.prototype.downloadUsers = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var impl;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impl = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var downloadUsersRequest, response;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        downloadUsersRequest = {
                                            Operation: 'DownloadUsers',
                                            Parameters: params,
                                        };
                                        return [4, this.connectionChannel.sendRequest(downloadUsersRequest)];
                                    case 1:
                                        response = _a.sent();
                                        if (utils_1.isExceptionalResponse(response)) {
                                            throw new Error(response.ExceptionMessage);
                                        }
                                        return [2, response.Result];
                                }
                            });
                        }); };
                        return [4, this.logAwaitRetryCBHandshake(impl, 'downloadUsers')()];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    CompanionClient.prototype.editDocument = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var impl;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impl = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var editDocumentRequest, response;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        editDocumentRequest = {
                                            Operation: 'EditDocument',
                                            Parameters: params,
                                        };
                                        return [4, this.connectionChannel.sendRequest(editDocumentRequest)];
                                    case 1:
                                        response = _a.sent();
                                        if (utils_1.isExceptionalResponse(response)) {
                                            throw new Error(response.ExceptionMessage);
                                        }
                                        return [2, response.Result];
                                }
                            });
                        }); };
                        return [4, this.logAwaitRetryCBHandshake(impl, 'editDocument')()];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    CompanionClient.prototype.setRestoreTask = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var impl;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impl = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var setRestoreTaskRequest, response;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        setRestoreTaskRequest = {
                                            Operation: 'SetRestoreTask',
                                            Parameters: params,
                                        };
                                        return [4, this.connectionChannel.sendRequest(setRestoreTaskRequest)];
                                    case 1:
                                        response = _a.sent();
                                        if (utils_1.isExceptionalResponse(response)) {
                                            throw new Error(response.ExceptionMessage);
                                        }
                                        return [2, response.Result];
                                }
                            });
                        }); };
                        return [4, this.logAwaitRetryCBHandshake(impl, 'setRestoreTask')()];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    CompanionClient.prototype.getCompanionVersion = function () {
        if (!!this.connectionChannel) {
            return this.connectionChannel.getCompanionVersion();
        }
        else {
            return undefined;
        }
    };
    CompanionClient.prototype.getSpecialFolderPaths = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var impl;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impl = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var getSpecialFolderPathsRequest, response;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        getSpecialFolderPathsRequest = {
                                            Operation: 'GetSpecialFolderPaths',
                                            Parameters: {},
                                        };
                                        return [4, this.connectionChannel.sendRequest(getSpecialFolderPathsRequest)];
                                    case 1:
                                        response = _a.sent();
                                        if (utils_1.isExceptionalResponse(response)) {
                                            throw new Error(response.ExceptionMessage);
                                        }
                                        return [2, response.Result];
                                }
                            });
                        }); };
                        return [4, this.logAwaitRetryCBHandshake(impl, 'getSpecialFolderPaths')()];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    CompanionClient.prototype.getBackupFoldersOrVolumes = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var impl;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impl = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var getBackupFoldersOrVolumesRequest, response;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        getBackupFoldersOrVolumesRequest = {
                                            Operation: 'GetBackupFoldersOrVolumes',
                                            Parameters: params,
                                        };
                                        return [4, this.connectionChannel.sendRequest(getBackupFoldersOrVolumesRequest)];
                                    case 1:
                                        response = _a.sent();
                                        if (utils_1.isExceptionalResponse(response)) {
                                            throw new Error(response.ExceptionMessage);
                                        }
                                        return [2, response.Result];
                                }
                            });
                        }); };
                        return [4, this.logAwaitRetryCBHandshake(impl, 'getBackupFoldersOrVolumes')()];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    CompanionClient.prototype.getCurrentRestoreTask = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var impl;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impl = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var getCurrentRestoreTaskRequest, response;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        getCurrentRestoreTaskRequest = {
                                            Operation: 'GetCurrentRestoreTask',
                                            Parameters: params,
                                        };
                                        return [4, this.connectionChannel.sendRequest(getCurrentRestoreTaskRequest)];
                                    case 1:
                                        response = _a.sent();
                                        if (utils_1.isExceptionalResponse(response)) {
                                            throw new Error(response.ExceptionMessage);
                                        }
                                        return [2, response.Result];
                                }
                            });
                        }); };
                        return [4, this.logAwaitRetryCBHandshake(impl, 'getCurrentRestoreTask')()];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    CompanionClient.prototype.configureBackup = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var impl;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impl = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var configureBackupRequest, response;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        configureBackupRequest = {
                                            Operation: 'ConfigureBackup',
                                            Parameters: {},
                                        };
                                        return [4, this.connectionChannel.sendRequest(configureBackupRequest)];
                                    case 1:
                                        response = _a.sent();
                                        if (utils_1.isExceptionalResponse(response)) {
                                            throw new Error(response.ExceptionMessage);
                                        }
                                        return [2, response.Result];
                                }
                            });
                        }); };
                        return [4, this.logAwaitRetryCBHandshake(impl, 'configureBackup')()];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    CompanionClient.prototype.getMachineInfo = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var impl;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impl = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var getMachineInfoRequest, response;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        getMachineInfoRequest = {
                                            Operation: 'GetMachineInfo',
                                            Parameters: {},
                                        };
                                        return [4, this.connectionChannel.sendRequest(getMachineInfoRequest)];
                                    case 1:
                                        response = _a.sent();
                                        if (utils_1.isExceptionalResponse(response)) {
                                            throw new Error(response.ExceptionMessage);
                                        }
                                        return [2, response.Result];
                                }
                            });
                        }); };
                        return [4, this.logAwaitRetryCBHandshake(impl, 'getMachineInfo')()];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    CompanionClient.prototype.purgeFileVersions = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var impl;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impl = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var purgeFileVersionsRequest, response;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        purgeFileVersionsRequest = {
                                            Operation: 'PurgeFileVersions',
                                            Parameters: params,
                                        };
                                        return [4, this.connectionChannel.sendRequest(purgeFileVersionsRequest)];
                                    case 1:
                                        response = _a.sent();
                                        if (utils_1.isExceptionalResponse(response)) {
                                            throw new Error(response.ExceptionMessage);
                                        }
                                        return [2, response.Result];
                                }
                            });
                        }); };
                        return [4, this.logAwaitRetryCBHandshake(impl, 'purgeFileVersions')()];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    CompanionClient.prototype.setAccessToken = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var impl;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impl = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                return [2, this.setAccessTokenBeforeConnectionChannelSet()];
                            });
                        }); };
                        return [4, this.logAwaitRetryCBHandshake(impl, 'setAccessToken')()];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    CompanionClient.prototype.setAccessTokenBeforeConnectionChannelSet = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var impl, withEmitMetricsAndLogs, withReconnectOnConnectivityIssue;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        impl = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var accessToken, tokenExpiration, isTokenExpirationValid, setAccessTokenRequest, response;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        accessToken = localStorage.getItem('gb_access_token');
                                        tokenExpiration = localStorage.getItem('gb_access_token_exp');
                                        isTokenExpirationValid = Date.parse(tokenExpiration);
                                        if (!isTokenExpirationValid) {
                                            tokenExpiration = null;
                                        }
                                        setAccessTokenRequest = {
                                            Operation: 'SetAccessToken',
                                            Parameters: {
                                                accessToken: accessToken,
                                                tokenExpiration: tokenExpiration,
                                            },
                                        };
                                        return [4, this.connectionChannel.sendRequest(setAccessTokenRequest)];
                                    case 1:
                                        response = _a.sent();
                                        if (utils_1.isExceptionalResponse(response)) {
                                            throw new Error(response.ExceptionMessage);
                                        }
                                        return [2, response.Result];
                                }
                            });
                        }); };
                        withEmitMetricsAndLogs = companionClientWrappers_1.emitMetricsAndLogs(impl, {
                            functionName: 'setAccessTokenBeforeConnectionChannelSet',
                            logger: this.logger,
                            metricService: this.metricService,
                            connectionChannel: this.connectionChannel,
                        });
                        withReconnectOnConnectivityIssue = companionClientWrappers_1.retryOnceAfterConnectivityIssue(withEmitMetricsAndLogs, {
                            functionName: 'setAccessTokenBeforeConnectionChannelSet',
                            getConnectionChannel: this.getConnectionChannel,
                            companionClientEventHandler: this.companionClientEventHandler,
                        });
                        return [4, withReconnectOnConnectivityIssue()];
                    case 1: return [2, _a.sent()];
                }
            });
        });
    };
    CompanionClient.prototype.logAwaitRetryCBHandshake = function (impl, functionName) {
        var withEmitMetricsAndLogs = companionClientWrappers_1.emitMetricsAndLogs(impl, {
            functionName: functionName,
            logger: this.logger,
            metricService: this.metricService,
            connectionChannel: this.connectionChannel,
        });
        var withReconnectOnConnectivityIssue = companionClientWrappers_1.retryOnceAfterConnectivityIssue(withEmitMetricsAndLogs, {
            functionName: functionName,
            getConnectionChannel: this.getConnectionChannel,
            companionClientEventHandler: this.companionClientEventHandler,
        });
        var withAwaitUntilConnectionChannelSet = companionClientWrappers_1.awaitUntilConnectionChannelSet(withReconnectOnConnectivityIssue, {
            companionClient: this,
        });
        var withSetConnectionChannelRetry = companionClientWrappers_1.retrySettingConnectionChannel(withAwaitUntilConnectionChannelSet, {
            companionClient: this,
            setConnectionChannel: this.setConnectionChannel,
            companionClientEventHandler: this.companionClientEventHandler,
        });
        return withSetConnectionChannelRetry;
    };
    return CompanionClient;
}());
exports.CompanionClient = CompanionClient;
